/** One "Write with AI" button (product / post editors): prompt popover → runAi → onResult(result). Never saves. */
import React, { useState } from 'react';
import { Button, Input, Popover, Space } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import { AiCreditBadge, reportAiError, runAi } from './ai';
import { useSite } from './common';

const ShopAiButton = ({ kind, body, onResult }) => {
    const { t } = useTranslation();
    const { siteId } = useSite();
    const [open, setOpen] = useState(false);
    const [prompt, setPrompt] = useState('');
    const [busy, setBusy] = useState(false);
    const go = async () => {
        if (!prompt.trim()) return;
        setBusy(true);
        try {
            const r = await runAi(siteId, kind, { ...(body || {}), prompt: prompt.trim() });
            onResult(r?.product || r?.post || r || {});
            setOpen(false);
        } catch (e) { reportAiError(e); } finally { setBusy(false); }
    };
    return (
        <Space size={4}>
            <Popover open={open} onOpenChange={(v) => !busy && setOpen(v)} trigger="click" placement="bottomRight" content={(
                <div style={{ width: 320 }}>
                    <Input.TextArea autoFocus value={prompt} onChange={(e) => setPrompt(e.target.value)} autoSize={{ minRows: 3, maxRows: 8 }}
                        placeholder={kind === 'post' ? t('What should the post be about?') : t('Describe the product')} onPressEnter={(e) => { if (e.metaKey || e.ctrlKey) go(); }} />
                    <Button type="primary" block style={{ marginTop: 8 }} loading={busy} disabled={!prompt.trim()} onClick={go}>{t('Generate')}</Button>
                </div>
            )}>
                <Button icon={<ThunderboltOutlined />}>{t('Write with AI')}</Button>
            </Popover>
            <AiCreditBadge />
        </Space>
    );
};

/** merge AI result into a form object without overwriting with empty values */
export const mergeAi = (cur, r, keys) => {
    const out = {};
    keys.forEach((k) => {
        const v = r?.[k];
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length)) return;
        if (k === 'seo' && typeof v === 'object') {
            const seo = { ...(cur.seo || {}) };
            if (v.title) seo.title = v.title;
            if (v.description) seo.description = v.description;
            out.seo = seo;
        } else out[k] = v;
    });
    return out;
};

export default ShopAiButton;
